import React from 'react';
import connect from '../../../../../js_bytesize/config/purchase/connect';
import Config from '../../../../../js_bytesize/config/purchase/config';

const refreshProductPurchaseContext = (Component) => {

  const Wrapper = (props) => {
    
    const refreshPurchaseContext = ({
      error
    }) => {
      let productId = getQueryParameterByName('product_id');
      let sameSubjectUpgrade = getQueryParameterByName('same_subject_upgrade');
      let params = {}
      const studentId = props.studentId;
      const fromPage = props.fromPage;
  
      if(!!productId){
        params = { product_id: productId }
      }
      if (!!location.hash.match('grade')) {
        const gradeMatch = location.hash.match(/grade=([^&]*)/);
        if (gradeMatch && gradeMatch[1]) {
          const gradeCode = gradeMatch[1];
          params = {
            ...params,
            grade_code: gradeCode,
          };
        }
      }
      params = {
        ...params,
        student_id: studentId 
      }
      if(sameSubjectUpgrade === "true") {
        params["same_subject_upgrade"] = true
      }
  
      if(props.settings.is_student_login){
        const ptlParent = props.ptlParent, parentDobYear = props.parentDobYear;
        const stripePaymentElement = {
          ...props.stripePaymentElement,
          error: error
        }
        Config.DataApi.studentProductList(function(data){
          props.initialize({...data, parentDobYear, ptlParent, stripePaymentElement });
          props.setParams({
            studentId: studentId,
            fromPage: fromPage
          });
        });
      } else {
        Config.DataApi.productList(params, function(data) {
          
          const isPitchElaUser = window.location.search.includes('is_pitch_ela=1');
          if((data.same_subject_upgrade || isPitchElaUser) && data.products.length == 0) {
            return location.href= '/';
          }
  
          const settingsPayload = data.settings
          settingsPayload.upgradable = data?.upgradable;
          data = { ...data, settings: { ...settingsPayload } }
  
          let newState = {
            ...data,
            settings: {
              ...props.settings, // to preserve old properties in setting which we don't need to update: refer ComponentDidMount in this file
              ...data.settings,
            },
            stripePaymentElement: {
              ...props.stripePaymentElement,
              error: error
            }
          }
          props.initialize({...newState });
          props.setParams({
            studentId: studentId,
            fromPage: fromPage
          });
        })
      }
    }
    return (
      <Component
        {...props}
        refreshPurchaseContext={refreshPurchaseContext}
      />
    );

  }

  function getQueryParameterByName(name) {
    var regex, results;
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    results = regex.exec(location.search);
    if (results === null) {
      return '';
    } else {
      return decodeURIComponent(results[1].replace(/\+/g, ' '));
    }
  };

  const mapStateToProps = (state) => {
    return {
      settings: state.settings,
      studentId: state.studentId,
      fromPage: state.fromPage,
      ptlParent: state.ptlParent,
      parentDobYear: state.parentDobYear,
      stripePaymentElement: state.stripePaymentElement
    }
  }

  const mapDispatchToProps = (dispatch) => {
    return {
      initialize: (data) => dispatch({type: "INITIALIZE", payload: data}),
      setParams: (data) => dispatch({type: 'SET_PARAMS', payload: data}),
      updateProductPurchaseContext: (data) => dispatch({type: "UPDATE_PRODUCT_PURCHASE_CONTEXT", payload: data}),
    }
  }

  return connect(mapStateToProps, mapDispatchToProps, Wrapper);
}

export default refreshProductPurchaseContext;

